module.exports = __webpack_public_path__ + "c2h4static/img/img-steps-2@2x.3e7128d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/img/img-steps-2@2x.png
// module id = Z2W1
// module chunks = 1